import { typography } from 'assets/styles'
import styled from 'styled-components'

export const Information = styled.p`
    ${typography.Copy14};
    color: ${(props) => props.theme.colors.monochrome.asphalt};
`
